module.exports = __webpack_public_path__ + "static/media/BabreyKoBato.55528d28.mp4";